import { AlertTriangle, Search } from "lucide-react";
import React, { useMemo, useState } from "react";
import ScrollTop from "../components/ScrollTop";

const ResourcesItem = ({
  title,
  description,
  publishedOn,
  documentUrl,
  onViewDocument,
}) => (
  <div className="bg-white rounded-lg shadow-sm p-4 border border-gray-200 hover:shadow-md hover:transform hover:scale-95 transition-transform duration-300 relative h-full flex flex-col">
    <h3 className="text-lg sm:text-xl md:text-2xl font-semibold mb-2 text-gray-800 line-clamp-2 overflow-hidden">
      {title}
    </h3>
    <p className="text-sm sm:text-base text-gray-600 text-justify mb-2 line-clamp-3 sm:line-clamp-4 overflow-hidden flex-grow">
      {description}
    </p>
    <p className="text-xs sm:text-sm text-gray-500 mb-2">
      Published On: {publishedOn}
    </p>
    <div className="flex justify-start">
      <button
        onClick={() => onViewDocument(documentUrl, title)}
        // className="w-1/2 inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-bold rounded-md shadow-sm text-white bg-tomato hover:bg-tomato-dark transition-colors duration-300"
      className="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-bold rounded-md shadow-sm text-white bg-tomato hover:bg-tomato-dark transition-colors duration-300"

      >
        View Document
      </button>
    </div>
  </div>
);

const resources = [
   {
    title: "Gam-Ind Constitution 2025-2026",
    description: "The latest version of our association's guiding principles.",
    publishedOn: "May 23, 2026",
    documentUrl: "/REVIEW DRAFT CRC 2024-2025.pdf",
  },
  {
    title: "Action Plan 2025-2026",
    description:
      "Action Plan entailing the activities the 9th executive council planned to do during their tenures from June 30th, 2025 to July 31st, 2026.",
    publishedOn: "May 23, 2026",
    documentUrl: "/Final Action plan.pdf", 
  },
  {
    title: "Audited Financial Report 2025-2026",
    description:
      "Audited financial report by the 9th Executive Council for the period 2025 to 2026.",
    publishedOn: "May 23, 2026",
    documentUrl: "/AUDITED FINANCIAL REPORT Q3 2025-2026.pdf",
  },
  {
    title: "Gam-Ind Constitution 2024",
    description: "The latest version of our association's guiding principles.",
    publishedOn: "July 1, 2024",
    documentUrl: "/Constitution.pdf",
  },
  {
    title: "Action Plan 2024-2025",
    description:
      "Action Plan entailing the activities the 8th executive council planned to do during their tenures from June 30th, 2024 to July 31st, 2025.",
    publishedOn: "June 31, 2024",
    documentUrl: "/GamInd Action Plan.pdf",
  },
  {
    title: "Activity Annual Report 2023",
    description:
      "Detailed Activities that was conducted by the 7th Executive Council for the period 2023 to 2024.",
    publishedOn: "28 June, 2024",
    documentUrl: "/GamInd Activity Report.pdf",
  },
  {
    title: "Financial Audit Report 2023",
    description:
      "An audit report by the 7th executive council which include details how the association manage incomes and expenses done during their tenure",
    publishedOn: "June 30th, 2024",
    documentUrl: "/GamInd Audit Report-2023.pdf",
  },
  {
    title: "Guidelines To Acquire Loan",
    description:
      "Procedures and guidelines for responding to emergencies and unforeseen events.",
    publishedOn: "September 25, 2024",
    documentUrl: "/emergency-preparedness-plan",
  },
];

const ResourcesSection = ({ onViewDocument }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [displayedItems, setDisplayedItems] = useState(8);

  const filteredResources = useMemo(() => {
    return resources.filter((item) =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);

  const handleViewMore = () => {
    setDisplayedItems(displayedItems + 8);
  };

  return (
    <div className="mt-4 sm:mt-6">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-0">
          Gam-Ind Resources and Reports
        </h2>
        <div className="relative w-full sm:w-auto">
          <input
            type="text"
            placeholder="Search resources..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full sm:w-64 px-4 py-2 border border-gray-300 rounded-full pl-10"
          />
          <Search
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            size={20}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
        {filteredResources.slice(0, displayedItems).map((item, index) => (
          <ResourcesItem
            key={index}
            {...item}
            onViewDocument={onViewDocument}
          />
        ))}
      </div>
      {displayedItems < filteredResources.length && (
        <div className="mt-6 text-center">
          <button
            onClick={handleViewMore}
            className="bg-tomato hover:bg-tomato-dark text-white font-bold py-2 px-4 rounded transition-colors duration-300"
          >
            View More
          </button>
        </div>
      )}
    </div>
  );
};

const MagazineItem = ({
  title,
  author,
  category,
  publishedOn,
  excerpt,
  coverImage,
  articleUrl,
  onViewArticle,
}) => (
  <div className="bg-white rounded-lg shadow-sm p-3 border border-gray-200 hover:shadow-md hover:transform hover:scale-95 transition-transform duration-300 relative h-full flex flex-col">
    <div className="relative w-full h-48 mb-4">
      <img
        src={coverImage}
        alt={title}
        className="w-full h-full object-cover rounded-md"
      />
      <span className="absolute top-2 right-2 bg-tomato text-white px-2 py-1 rounded-full text-xs">
        {category}
      </span>
    </div>
    <h3 className="text-lg sm:text-xl font-semibold mb-2 text-gray-800 line-clamp-2 overflow-hidden">
      {title}
    </h3>
    <p className="text-sm text-gray-600 mb-2">By {author}</p>
    <p className="text-sm text-gray-500 mb-2">Published: {publishedOn}</p>
    <p className="text-sm text-gray-600 mb-4 line-clamp-3 overflow-hidden flex-grow">
      {excerpt}
    </p>
    <button
      onClick={() => onViewArticle(articleUrl, title)}
      className="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-bold rounded-md shadow-sm text-white bg-tomato hover:bg-tomato-dark transition-colors duration-300"
    >
      Read Article
    </button>
  </div>
);

const magazineArticles = [
  {
    title: "The Story About Gam-Ind",
    author: "Muhammed S Jallow",
    category: "Technology",
    publishedOn: "August 15, 2024",
    excerpt: "Explore the rich flavors and traditions of Gambian cooking...",
    coverImage: "https://i.ibb.co/km2dmdh/Simple-Travel-Magazine-Cover.png",
    articleUrl: "/gam_magaz.html",
  },
  {
    title: "Innovation in Sustainable Agriculture",
    author: "Lamin Jallow",
    category: "Technology",
    publishedOn: "September 1, 2024",
    excerpt: "Discover how Gambian farmers are embracing new technologies...",
    coverImage: "https://i.ibb.co/vV1h0gQ/Travel-Magazine-Cover-Website.png",
    articleUrl: "/Constitution.pdf",
  },
  {
    title: "The Rising Stars of Gambian Music",
    author: "Isatou Baldeh",
    category: "Arts",
    publishedOn: "September 10, 2024",
    excerpt:
      "Meet the new generation of Gambian writers shaping the literary landscape...",
    coverImage: "https://i.ibb.co/TrcdBMd/Modou-Lamin-Ceesay.jpg",
    articleUrl: "/articles/rising-stars-gambian-literature.html",
  },
  {
    title: "Preserving Gambian Traditional Music",
    author: "Modou Touray",
    category: "Culture",
    publishedOn: "September 15, 2024",
    excerpt:
      "How local musicians are keeping Gambian musical heritage alive...",
    coverImage: "https://i.ibb.co/TgGxF0Q/njies-cul.jpg",
    articleUrl: "/articles/preserving-gambian-music.html",
  },
];

const MagazineSection = ({ onViewArticle }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [displayedItems, setDisplayedItems] = useState(8);

  const filteredArticles = useMemo(() => {
    return magazineArticles.filter(
      (item) =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.author.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.category.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);

  const handleViewMore = () => {
    setDisplayedItems(displayedItems + 8);
  };

  return (
    <div className="mt-4 sm:mt-6">
      <div className="flex flex-col sm:flex-row sm:justify-between items-start mb-6">
        <h2 className="text-3xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-0 sm:text-left">
          Gam-Ind Magazine
        </h2>
        <div className="relative w-full sm:w-auto mt-2 sm:mt-0">
          <input
            type="text"
            placeholder="Search articles..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full sm:w-64 px-4 py-2 border border-gray-300 rounded-full pl-10"
          />
          <Search
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            size={20}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
        {filteredArticles.slice(0, displayedItems).map((item, index) => (
          <MagazineItem key={index} {...item} onViewArticle={onViewArticle} />
        ))}
      </div>
      {displayedItems < filteredArticles.length && (
        <div className="mt-6 text-center">
          <button
            onClick={handleViewMore}
            className="bg-tomato hover:bg-tomato-dark text-white font-bold py-2 px-4 rounded transition-colors duration-300"
          >
            View More
          </button>
        </div>
      )}
    </div>
  );
};

const DocumentErrorAlert = ({ documentTitle, onGoBack }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isPopping, setIsPopping] = useState(false);

  const handleGoBack = () => {
    setIsLoading(true);
    setIsPopping(true);
    setTimeout(() => {
      onGoBack();
    }, 1000);
  };

  return (
    <div
      className={`min-h-screen bg-gray-100 flex items-center justify-center px-6 ${
        isPopping ? "animate-pop" : ""
      }`}
    >
      <div className="max-w-md w-full bg-yellow-50 rounded-lg shadow-md p-6 sm:p-8 border-2 border-yellow-400">
        <ScrollTop />
        <div className="text-center">
          <AlertTriangle className="mx-auto h-12 w-12 sm:h-16 sm:w-16 text-yellow-500 mb-4" />
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
            Oops! Something went wrong
          </h2>
          <p className="text-sm sm:text-base text-gray-600 font-semibold mb-4 sm:mb-6">
            We're having trouble displaying the document "{documentTitle}". This
            could be due to the following reasons:
          </p>
          <ul className="text-left text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 list-disc list-inside">
            <li>The document doesn't exist</li>
            <li>There's an issue with the file</li>
            <li>You don't have permission to view this document</li>
          </ul>
          <div className="space-y-4">
            <p className="text-sm sm:text-base text-gray-600 font-semibold">
              Please reach out to our support team at{" "}
              <a
                href="mailto:support@gamind.org"
                className="text-blue-500 underline hover:text-blue-600"
              >
                support@gamind.org
              </a>{" "}
              for further assistance.
            </p>
            <button
              onClick={handleGoBack}
              disabled={isLoading}
              className={`w-full bg-tomato hover:bg-tomato-dark text-white font-bold py-2 px-4 rounded transition duration-300 ${
                isLoading ? "cursor-not-allowed" : ""
              }`}
            >
              {isLoading ? (
                <span className="flex justify-center items-center">
                  <svg
                    className="animate-spin h-5 w-5 text-white mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 100 8v4a8 8 0 01-8-8z"
                    ></path>
                  </svg>
                  Loading...
                </span>
              ) : (
                "Go Back to Resources"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Resources = () => {
  const [documentError, setDocumentError] = useState(false);
  const [errorDocumentTitle, setErrorDocumentTitle] = useState("");
  const [activeTab, setActiveTab] = useState("resources");

  // Resources sections
  const handleViewDocument = (documentUrl, title) => {
    if (documentUrl.match(/^\/[a-zA-Z0-9- _]+\.pdf$/)) {
      const documentExists = resources.some(
        (doc) => doc.documentUrl === documentUrl
      );

      if (documentExists) {
        window.open(documentUrl, "_blank");
      } else {
        setDocumentError(true);
        setErrorDocumentTitle(title);
      }
    } else {
      setDocumentError(true);
      setErrorDocumentTitle(title);
    }
  };

  // Articles sections
  const handleViewArticle = (articleUrl, title) => {
    // Logging for debugging
    console.log("Article URL: ", articleUrl);

    // Define the regex pattern for both HTML and PDF files
    const regexPattern = /^\/[a-zA-Z0-9-_ ]+\.(html|pdf)$/;

    // Check if the URL matches the expected pattern
    if (articleUrl.match(regexPattern)) {
      // Check if the article exists in the list
      const articleExists = magazineArticles.some(
        (article) => article.articleUrl === articleUrl
      );

      if (articleExists) {
        // Log to confirm the article exists
        console.log("Article exists. Opening:", articleUrl);
        // Open the article in a new tab
        window.open(articleUrl, "_blank");
      } else {
        // Log the error case
        console.log("Article not found:", articleUrl);
        setDocumentError(true);
        setErrorDocumentTitle(title);
      }
    } else {
      // Log the case when the URL doesn't match the pattern
      console.log("Invalid article URL format:", articleUrl);
      setDocumentError(true);
      setErrorDocumentTitle(title);
    }
  };

  const handleGoBack = () => {
    setDocumentError(false);
    setErrorDocumentTitle("");
  };

  if (documentError) {
    return (
      <DocumentErrorAlert
        documentTitle={errorDocumentTitle}
        onGoBack={handleGoBack}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-200">
      <div
        className="relative bg-cover bg-center py-20 sm:py-32 md:py-44"
        style={{
          backgroundImage: "url('https://i.ibb.co/tKLDkH3/river-gambia.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-black opacity-60"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-2 relative z-10">
            Gam-Ind Resources & Magazine
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-300">
            Explore our guiding resources and member contributions
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-6 sm:py-8">
        <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 md:p-8 border border-gray-200">
          <div className="mb-6">
            <div className="flex border-b border-gray-200">
              <button
                className={`py-2 px-4 font-semibold ${
                  activeTab === "resources"
                    ? "text-tomato border-b-2 border-tomato"
                    : "text-gray-500 hover:text-gray-700"
                }`}
                onClick={() => setActiveTab("resources")}
              >
                Resources
              </button>
              <button
                className={`py-2 px-4 font-semibold ${
                  activeTab === "magazine"
                    ? "text-tomato border-b-2 border-tomato"
                    : "text-gray-500 hover:text-gray-700"
                }`}
                onClick={() => setActiveTab("magazine")}
              >
                Magazines
              </button>
            </div>
          </div>
          {activeTab === "resources" ? (
            <ResourcesSection onViewDocument={handleViewDocument} />
          ) : (
            <MagazineSection onViewArticle={handleViewArticle} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Resources;
